import { ForwardedRef, forwardRef } from 'react';
import { InputProps, TextAreaProps } from '../../Types';

export const Input = forwardRef(({ className, name, type, ...props }: InputProps, ref: ForwardedRef<HTMLInputElement>) => {
  return <input className={className} name={name} type={type} ref={ref} {...props} />;
});

Input.displayName = 'FormInput';

export const TextArea = forwardRef(({ className, name, limit, ...props }: TextAreaProps, ref: ForwardedRef<HTMLTextAreaElement>) => {
  return <textarea className={className} name={name} maxLength={limit} ref={ref} {...props}></textarea>;
});

TextArea.displayName = 'FormTextArea';
